import { render, staticRenderFns } from "./SimpleBar.vue?vue&type=template&id=57ee7503&"
import script from "./SimpleBar.vue?vue&type=script&lang=js&"
export * from "./SimpleBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports